import AppRoutes from '@components/routes/app-routes'
import { ToastContainer, Slide } from 'react-toastify'

import './app.scss'

function App() {
  return (
    <>
      <AppRoutes />
      <ToastContainer
        position='top-center'
        autoClose={3000}
        closeButton={false}
        transition={Slide}
        hideProgressBar
        closeOnClick
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
      />
    </>
  )
}

export default App
